module.exports = __webpack_public_path__ + "img/qrcode.08977e83.png";